import { Text } from "@simplybusiness/mobius";
import type { AgentReferralReasonsProps } from "./types";
import { InfoCard } from "./InfoCard";

export const AgentReferralReasons = (props: AgentReferralReasonsProps) => {
  const { firstName, referralReasons } = props;

  return (
    <div className="mobius-agent-referral__reasons">
      <Text variant="h3">
        Sorry! Here are some key factors why we couldn&apos;t get any quotes for{" "}
        {firstName}
      </Text>
      {referralReasons.map(({ title, description }) => (
        <InfoCard key={title} header={title}>
          {description}
        </InfoCard>
      ))}
    </div>
  );
};
